<template>
  <EmailAddress
    :value="emailAddress"
    data-id="inbox-email-address"
    :short="short"
    :data-value="emailAddress"
    :copy="copy"
  />
</template>

<script setup lang="ts">
import type {
  InboxDto as Inbox,
  InboxPreview as InboxProjection,
} from '@mailslurp/admin-sdk';
import EmailAddress from '../../components/form/EmailAddress.vue';
import { computed } from 'vue';
import { useStore3 } from '../../store/main';

const props = withDefaults(
  defineProps<{
    inbox: InboxProjection | Inbox;
    copy?: boolean;
    short?: boolean;
  }>(),
  {
    copy: true,
    short: false,
  },
);
const store3 = useStore3();
const emailAddress = computed(() => {
  if (store3?.regressionTest) {
    return 'email@mailslurp.net';
  } else {
    return props.inbox.emailAddress
      ? props.inbox.emailAddress
      : `${props.inbox.id}@mailslurp.net`;
  }
});
</script>
